module.exports = __webpack_public_path__ + "img/up.c812f293.png";